module.exports = __webpack_public_path__ + "static/majka-min-b70522d3d1db1f5cdb3b11bdfb40e95c.png";